import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { NecttosContext } from '../../../context/NecttosContext';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import FileUpload from '../ui/FileUpload';

interface Question {
  questionText: string;
  options: string[];
  correctAnswer: string;
}

interface Assignment {
  _id: string;
  type: 'assignment' | 'quiz';
  title?: string;
  timeLimit?: number;
  timeLimitUnit: string;
  dueDate?: string;
  description: string;
  maxMark: number;
  moduleId: string;
  submissionCount: number;
  status: string;
  questions?: Question[];
}

interface ViewAssignmentSectionProps {
  assignment: Assignment;
  onBack?: () => void;
}

const ViewAssignmentSection: React.FC<ViewAssignmentSectionProps> = ({ assignment, onBack }) => {
  const [answers, setAnswers] = useState<{ [index: number]: string }>({});
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [assignmentFormData, setSelectedAssignmentFormData] = useState<any>();
  const [quizStarted, setQuizStarted] = useState<boolean>(false)



  const handleOptionSelect = (qIndex: number, option: string) => {
    setAnswers(prev => ({ ...prev, [qIndex]: option }));
  };
  
  const handleSubmit = () => {
    console.log('Submitted Answers:', answers);
    // TODO: Add actual submission logic here
  };
  const handleStartQuiz = () => {
    setQuizStarted((prev) => !prev)
  }
 
  const handleAssignmentSubmit = () => {

  }

  const handleFileUpload = async (file: File) => {
      // const file = event.target.files ? event.target.files[0] : null;
    
      if (!file) {
        message.error('No file selected.');
        return;
      }
    
      if (file.size > 10 * 1024 * 1024) {
        message.error(`File size must be less than 10 MB.`);
        return;
      }
    
      setIsUploading(true);
    
      try {
        const downloadURL = await uploadFileToFirebase(file);
        if (downloadURL) {
//          setFormData(prev => ({
//     ...prev,
//     attachments: {
//       name: file.name,
//       url: downloadURL,
//       size: file.size,
//       type: file.type
//     }
//   }));
  
  
          message.success(`${file.name} uploaded successfully.`);
        }
      } catch (err) {
        console.error('Upload failed:', err);
        message.error('Failed to upload file. Please try again.');
      } finally {
        setIsUploading(false);
      }
    };
    
    
      const uploadFileToFirebase = async (file: File): Promise<string | null> => {
   
    const storage = getStorage();
        const filePath = `materials/HELLO/JAA/${file.name}`;
        const fileRef = ref(storage, filePath);
      
        const snapshot = await uploadBytes(fileRef, file, {
          contentType: file.type
        });
    
      const downloadURL = await getDownloadURL(snapshot.ref);
      return downloadURL;
    };
    
  
    // const handleSubmit = async (e: React.FormEvent) => {
    //   e.preventDefault();
    //  const instance = await getAxiosTokenInstance()
      
    //   if (!validateForm()) {
    //     return;
    //   }
  
    //   setIsSubmitting(true);
      
    //   try {
    //     const resp = await instance.post(`/college/lms/materials/createMaterial`, {...formData, collegeId:collegeId});
    //     if(resp?.data){
    //       console.log(resp?.data.message)
    //      message.success('Material added')
    //     }
    //     handleReset();
    //     onClose();
    //   } catch (error) {
    //     console.error('Error creating learning material:', error);
    //   } finally {
    //     setIsSubmitting(false);
    //   }
    // };
  
  const handleFileChange = () => {

  }
  const handleCommentChange = () => {

  }

  return (
    <div className="p-6 max-w-4xl mx-auto space-y-6">
      <button
        onClick={onBack}
        className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
      >
        ← Back
      </button>
      

      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md border border-gray-200 dark:border-gray-700 space-y-4">
  <h2 className="text-xl font-semibold text-gray-800 dark:text-white">Assignment Details</h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-700 dark:text-gray-200">
    <div>
      <p className="font-medium">ID</p>
      <p className="text-gray-500 dark:text-gray-400">{assignment._id}</p>
    </div>

    <div>
      <p className="font-medium">Type</p>
      <p className="text-gray-500 dark:text-gray-400 capitalize">{assignment.type}</p>
    </div>

    <div>
      <p className="font-medium">Status</p>
      <p className="text-gray-500 dark:text-gray-400">{assignment.status}</p>
    </div>

    <div>
      <p className="font-medium">Due Date</p>
      {/* <p className="text-gray-500 dark:text-gray-400">
        {new Date(assignment.dueDate).toLocaleString()}
      </p> */}
    </div>

    <div>
      <p className="font-medium">Max Marks</p>
      <p className="text-gray-500 dark:text-gray-400">{assignment.maxMark}</p>
    </div>

    <div>
      <p className="font-medium">Module ID</p>
      <p className="text-gray-500 dark:text-gray-400">{assignment.moduleId}</p>
    </div>

    <div>
      <p className="font-medium">Submissions</p>
      <p className="text-gray-500 dark:text-gray-400">{assignment.submissionCount}</p>
    </div>

    <div className="sm:col-span-2">
      <p className="font-medium">Description</p>
      <p className="text-gray-500 dark:text-gray-400">{assignment.description}</p>
    </div>
  </div>
</div>
{assignment.type === 'quiz' && !quizStarted && (
        <div className="text-center space-y-4">
          <h2 className="text-2xl font-bold">{assignment.title}</h2>
          <p className="text-gray-500">{assignment.description}</p>
          <p className="text-sm text-gray-600">Time Limit: {assignment.
timeLimit} {assignment.timeLimitUnit}</p>
          <button
            onClick={handleStartQuiz}
            className="px-6 py-2 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700"
          >
            Start Quiz
          </button>
        </div>)}
{assignment.type === 'quiz' && quizStarted && (
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md border border-gray-200 dark:border-gray-700 space-y-4">
        <h2 className="text-xl font-semibold text-gray-800 dark:text-white">Quiz: {assignment.description}</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">Max Marks: {assignment.maxMark}</p>

        {assignment?.questions?.map((q, index) => (
          <div key={index} className="border-t pt-4 mt-4">
            <h3 className="font-medium text-gray-700 dark:text-gray-200 mb-2">{index + 1}. {q.questionText}</h3>
            <div className="grid gap-2">
              {q.options.map((option, optIndex) => (
                <label key={optIndex} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name={`question-${index}`}
                    value={option}
                    checked={answers[index] === option}
                    onChange={() => handleOptionSelect(index, option)}
                    className="text-blue-600 focus:ring-blue-500 border-gray-300"
                  />
                  <span className="text-gray-600 dark:text-gray-300">{option}</span>
                </label>
              ))}
            </div>
          </div>
        ))}

        <div className="pt-6">
          <button
            onClick={handleSubmit}
            className="px-6 py-2 rounded-lg text-white bg-blue-600 hover:bg-blue-700 font-medium shadow-sm"
          >
            Submit Quiz
          </button>
        </div>
      </div>
      )}
      {assignment.type === 'assignment' && (
  <form className="space-y-6 mt-6 bg-white dark:bg-gray-800 p-6 rounded-xl shadow border border-gray-200 dark:border-gray-700">
    <h3 className="text-xl font-semibold text-gray-800 dark:text-white">Submit Your Assignment</h3>

    {/* File Upload */}
           
             <label className="block text-sm font-medium text-gray-700 mb-2">
               Learning Materials *
             </label>
             <FileUpload
     onFilesSelected={async (files: File[]) => {
       const file = files[0];
      
      handleFileUpload(file);
     }}
     label="Upload assignment materials"
   />

    {/* Optional Comment */}
    <div>
      <label className="block font-medium text-gray-700 dark:text-gray-300 mb-1">
        Comment (optional)
      </label>
      <textarea
        className="w-full px-3 py-2 border rounded-md text-sm border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
        rows={4}
        placeholder="Add any notes or explanations here..."
        onChange={handleCommentChange}
      />
    </div>

    {/* Submit Button */}
    <div className="pt-4">
      <button
        type="submit"
        onClick={handleAssignmentSubmit}
        className="px-6 py-2 rounded-lg text-white bg-green-600 hover:bg-green-700 font-medium shadow-sm"
      >
        Submit Assignment
      </button>
    </div>
  </form>
)}

    </div>
  );
};

export default ViewAssignmentSection;
